import React from 'react';
export var Error = function Error(props) {
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10.9362",
    cy: "11.3203",
    r: "9.84583",
    stroke: props.color || '#C93313',
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0223 17.2603C11.7423 17.2603 12.3183 16.7163 12.3183 16.0283C12.3183 15.3243 11.7423 14.7803 11.0223 14.7803C10.3183 14.7803 9.74233 15.3243 9.74233 16.0283C9.74233 16.7163 10.3183 17.2603 11.0223 17.2603ZM10.2543 13.7083H11.8223L12.1263 5.70831H9.96633L10.2543 13.7083Z",
    fill: props.color || '#C93313',
    stroke: props.color || '#C93313',
    strokeWidth: ".3"
  }));
};